// extracted by mini-css-extract-plugin
export default {"formItem":"MinMaxInput_formItem__MkT+X"};